import { render } from "./DesignationWiseUserCount.vue?vue&type=template&id=0df628ea"
import script from "./DesignationWiseUserCount.vue?vue&type=script&lang=js"
export * from "./DesignationWiseUserCount.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/teachers.gov.bd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__